var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop, ClipPath } from "react-native-svg";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#edit_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "url(#edit_svg__b)",
    d: "m1.875 8.25 1.875 1.875 6.375-6.375L8.25 1.875z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#FFED9F",
    d: "m1.125 10.875 2.625-.75L1.875 8.25z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#edit_svg__c)",
    d: "m8.625 1.5.75-.75q.563-.562 1.125 0l.75.75q.563.563 0 1.125l-.75.75z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    d: "M2.625 8.625 8.25 3z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#C88200",
    strokeWidth: 1.2,
    d: "M2.625 8.625 8.25 3"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "edit_svg__b",
    x1: 6,
    x2: 6,
    y1: 10.125,
    y2: 1.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#B25200"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.08,
    stopColor: "#F58F00"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.604,
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "edit_svg__c",
    x1: 10.078,
    x2: 10.078,
    y1: 3.375,
    y2: 0.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#B25200"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.08,
    stopColor: "#F58F00"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.604,
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "edit_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgEdit;